import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EntityStatus } from '@guryou/core';
import { getCalendarEvents, StateStatus } from '@guryou/redux';
import { format } from 'date-fns';

import { resetState } from '../actions';
import {
  RESERVATIONS_CANCEL,
  RESERVATIONS_CREATE,
  RESERVATIONS_UPDATE,
  SESSION_FROM_EVENT,
  SUBSCRIPTIONS_CANCEL,
  SUBSCRIPTIONS_CREATE,
  SUBSCRIPTIONS_UPDATE,
} from '../new';
import { CALENDAR_EVENTS } from '../types';

import { useEffectOnError, useEffectOnSuccess } from '.';

const useCalendarEvents = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.calendar.calendarEvents);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getCalendarEvents());
    }
  }, [dispatch, status]);

  useEffectOnSuccess(
    [
      state => state.reservations.create,
      state => state.reservations.update,
      state => state.reservations.cancel,
      state => state.subscriptions.create,
      state => state.subscriptions.update,
      state => state.subscriptions.cancel,
    ],
    () => {
      dispatch(resetState(CALENDAR_EVENTS));
      dispatch(resetState(RESERVATIONS_CREATE));
      dispatch(resetState(RESERVATIONS_UPDATE));
      dispatch(resetState(RESERVATIONS_CANCEL));
      dispatch(resetState(SUBSCRIPTIONS_CREATE));
      dispatch(resetState(SUBSCRIPTIONS_UPDATE));
      dispatch(resetState(SUBSCRIPTIONS_CANCEL));
      dispatch(resetState(SESSION_FROM_EVENT));
    }
  );

  useEffectOnError(
    [
      state => state.reservations.create,
      state => state.reservations.update,
      state => state.reservations.cancel,
      state => state.subscriptions.create,
      state => state.subscriptions.update,
      state => state.subscriptions.cancel,
      state => state.sessions.create,
      state => state.sessions.updateFromEvent,
      state => state.sessions.update,
    ],
    () => {
      dispatch(resetState(RESERVATIONS_CREATE));
      dispatch(resetState(RESERVATIONS_UPDATE));
      dispatch(resetState(RESERVATIONS_CANCEL));
      dispatch(resetState(SUBSCRIPTIONS_CREATE));
      dispatch(resetState(SUBSCRIPTIONS_UPDATE));
      dispatch(resetState(SUBSCRIPTIONS_CANCEL));
      dispatch(resetState(SESSION_FROM_EVENT));
    }
  );

  return {
    data: data
      ?.filter(el => el.status !== EntityStatus.canceled && el.startTime > format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"))
      .sort((a, b) => new Date(a.startTime) - new Date(b.startTime)),
    status,
    version,
    entity,
    request,
  };
};

export default useCalendarEvents;
